"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providers = exports.resolveProvider = void 0;
/**
 * A function that constructs provider based on raw input data.
 *
 * @export
 * @param {ProviderReference} provider object containing provider name and api key
 * @returns {Provider} constructed provider
 */
function resolveProvider(provider) {
    const existentProvider = exports.providers[provider.name];
    if (!existentProvider) {
        throw "No provider with this name. Please use a provider from the supported providers list.";
    }
    // attaching key
    existentProvider.key = provider.key;
    return existentProvider;
}
exports.resolveProvider = resolveProvider;
/**
 * Provider map initialization
 */
exports.providers = {
    ExchangeRateAPI: {
        endpoint: {
            base: "https://api.exchangerate-api.com/v4/latest/",
            single: "%FROM%",
            multiple: "%FROM%"
        },
        key: undefined,
        handler: function (data) {
            return data.rates;
        },
        errors: { 400: "Malformed query.", 404: "Currency not found" },
        errorHandler: function (data) {
            return data.status;
        }
    },
    ExchangeRatesAPIIO: {
        endpoint: {
            base: "http://api.exchangeratesapi.io/latest?access_key=%KEY%",
            single: "&base=%FROM%&symbols=%TO%",
            multiple: "&base=%FROM%"
        },
        errors: {
            105: "A paid plan is required in order to use other base currencies!",
            101: "Invalid API key!",
            201: "Invalid base currency."
        },
        key: undefined,
        handler: function (data) {
            return data.rates;
        },
        errorHandler: function (data) {
            return data.status;
        }
    },
    CurrencyLayer: {
        endpoint: {
            base: "http://apilayer.net/api/live?access_key=%KEY%",
            single: "&source=%FROM%",
            multiple: "&source=%FROM%&currencies=%TO%"
        },
        key: undefined,
        handler: function (data) {
            const map = {};
            Object.keys(data.quotes).map((key) => {
                map[key.slice(3)] = data.quotes[key];
            });
            return map;
        },
        errors: {
            105: "A paid plan is required in order to use CurrencyLayer (base currency use not allowed)",
            101: "Invalid API key!",
            201: "Invalid base currency.",
            106: "No results."
        },
        errorHandler: function (data) {
            return data.error ? data.error.code : null;
        }
    },
    OpenExchangeRates: {
        endpoint: {
            base: "https://openexchangerates.org/api/latest.json?app_id=%KEY%",
            single: "&base=%FROM%",
            multiple: "&base=%FROM%"
        },
        key: undefined,
        handler: function (data) {
            return data.rates;
        },
        errors: {
            401: "Invalid API key!"
        },
        errorHandler: function (data) {
            return data.status;
        }
    },
    AlphaVantage: {
        endpoint: {
            base: "https://www.alphavantage.co/query?function=CURRENCY_EXCHANGE_RATE&apikey=%KEY%",
            single: "&from_currency=%FROM%&to_currency=%TO%",
            multiple: ""
        },
        key: undefined,
        handler: function (data) {
            const map = {};
            const o = data[Object.keys(data)[0]];
            map[o["3. To_Currency Code"]] = o["5. Exchange Rate"];
            return map;
        },
        errors: {
            503: "Invalid API key or Malformed query."
        },
        errorHandler: function (data) {
            return data["Error Message"] ? 503 : false;
        }
    },
    Fixer: {
        endpoint: {
            base: "http://data.fixer.io/api/latest?access_key=%KEY%",
            single: "&base=%FROM%&symbols=%TO%",
            multiple: "&base=%FROM%"
        },
        key: undefined,
        handler: function (data) {
            return data.rates;
        },
        errors: {
            105: "A paid plan is required in order to use Fixer.io (base currency use not allowed)",
            101: "Invalid API key!",
            201: "Invalid base currency."
        },
        errorHandler: function (data) {
            return data.error ? data.error.code : null;
        }
    }
};
//# sourceMappingURL=data:application/json;base64,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